var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11111 0H24.8889C25.714 0 26.5053 0.327777 27.0888 0.911223C27.6722 1.49467 28 2.28599 28 3.11111V24.8889C28 25.714 27.6722 26.5053 27.0888 27.0888C26.5053 27.6722 25.714 28 24.8889 28H3.11111C2.28599 28 1.49467 27.6722 0.911223 27.0888C0.327777 26.5053 0 25.714 0 24.8889V3.11111C0 2.28599 0.327777 1.49467 0.911223 0.911223C1.49467 0.327777 2.28599 0 3.11111 0ZM23.3333 3.11111H19.4444C18.0005 3.11111 16.6157 3.68472 15.5946 4.70575C14.5736 5.72678 14 7.1116 14 8.55556V12.4444H10.8889V17.1111H14V28H18.6667V17.1111H23.3333V12.4444H18.6667V9.33333C18.6667 8.92077 18.8306 8.52511 19.1223 8.23339C19.414 7.94167 19.8097 7.77778 20.2222 7.77778H23.3333V3.11111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFace);
export default __webpack_public_path__ + "static/media/ic_face.e55d9c545e61b5f0db0e56b7f4a148b7.svg";
export { ForwardRef as ReactComponent };